/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BAppService } from '../service/bApp.service';
import { Http } from '@angular/http';
import { BLoginService } from '../service/bLogin.service';
import { PubSubService } from '../service/pubSub.service';
import { MatDialog } from '@angular/material';
import { SystemService } from '../service/system.service';
/**
* Model import Example :
* import { HERO } from '../models/hero.model.ts';
*/
var loginComponent = (function () {
    function loginComponent(router, bLoginService, http, bAppService, pubSubService, dialog, ngZone) {
        this.router = router;
        this.bLoginService = bLoginService;
        this.http = http;
        this.bAppService = bAppService;
        this.pubSubService = pubSubService;
        this.dialog = dialog;
        this.ngZone = ngZone;
        this.userInvalid = false;
        this.user = {
            'name': '',
            'pass': '',
            'isRemember': false
        };
        this.systemService = new SystemService();
        this.isMobileVar = true;
    }
    loginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isMobileVar = this.isMobile();
        if (this.bLoginService.isLoggedIn()) {
            this.ngZone.run(function () {
                _this.router.navigate(['/']);
            });
        }
        if (this.systemService.deviceType != 'browser') {
            this.isRememberBoolean = true;
            this.user.isRemember = true;
        }
    };
    loginComponent.prototype.handleKeyboardEvent = function (event) {
        if (event && event.key == 'Enter' && this.user && this.user['name'] && this.user['pass']) {
            this.login();
        }
    };
    loginComponent.prototype.login = function () {
        var _this = this;
        this.userInvalid = false;
        if (this.user.name && this.user.pass) {
            this.bLoginService.login(this.user.name, this.user.pass, this.user.isRemember).subscribe(function (response) {
                _this.ngZone.run(function () {
                    _this.router.navigate(['bhive']);
                });
            }, function (error) {
                if (error.error == 'Invalid username and / or password.') {
                    _this.userInvalid = true;
                }
            });
        }
        else {
            this.bAppService.openSnackBar('Please enter a Username or Password');
        }
    };
    loginComponent.prototype.isMobile = function () {
        var platform = this.systemService.deviceType;
        if (platform === 'browser') {
            return false;
        }
        return true;
    };
    loginComponent.prototype.ngOnDestroy = function () {
        //this.fBRegCompSub.unsubscribe();
    };
    return loginComponent;
}());
export { loginComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/loginComponent/login.component.ts.pre-build-optimizer.js